// Hamburger menu toggle
const hamburger = document.getElementById('hamburger');
const navLinks = document.getElementById('nav-links');
if (hamburger && navLinks) {
    hamburger.addEventListener('click', ()=>{
        navLinks.classList.toggle('open');
    });
    // Close menu when a link is clicked
    navLinks.querySelectorAll('a').forEach((link)=>{
        link.addEventListener('click', ()=>navLinks.classList.remove('open'));
    });
}
// Contact form submission
const contactForm = document.getElementById('contact-form');
if (contactForm) {
    const submitBtn = document.getElementById('submit-btn');
    const successMsg = document.getElementById('form-success');
    const errorMsg = document.getElementById('form-error');
    contactForm.addEventListener('submit', async (e)=>{
        e.preventDefault();
        successMsg.classList.remove('show');
        errorMsg.classList.remove('show');
        const name = document.getElementById('name').value.trim();
        const email = document.getElementById('email').value.trim();
        const message = document.getElementById('message').value.trim();
        if (!name || !email || !message) {
            errorMsg.textContent = 'Please fill in all required fields.';
            errorMsg.classList.add('show');
            return;
        }
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
        try {
            const res = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name,
                    email,
                    subject: document.getElementById('subject')?.value.trim() || '',
                    message
                })
            });
            if (res.ok) {
                contactForm.reset();
                successMsg.classList.add('show');
            } else throw new Error('Server error');
        } catch  {
            errorMsg.textContent = 'Something went wrong. Please try again, or email us directly at hello@zezume.com.';
            errorMsg.classList.add('show');
        } finally{
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Message';
        }
    });
}

//# sourceMappingURL=public.9bb589f5.js.map
